import { CdnApiClient } from "../../clients/cdn-client";

export class StaticRepository {
    private _client: CdnApiClient;

    constructor() {
        this._client = new CdnApiClient('/v2/static');
    }

    async getLocalization(): Promise<Localization> {
        const res = await fetch('/localizations.json');

        const text = await res.text()
        return JSON.parse(text);
    }

    // async getLocalization(): Promise<Localization> {
    //     return await this._client.getSimple<Localization>('localizations.json');
    // }
}